module.exports = __webpack_public_path__ + "3a3cdec23d19472ef7f29f427618677f.svg";